<template>
  <v-navigation-drawer
    v-if="isViewInboxMessageModalOpen"
    :value="isViewInboxMessageModalOpen"
    @input="inputViewInboxMessageModal"
    width="700"
    temporary
    fixed
    right
    class="grey lighten-3"
    style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
  >
    <div class="mt-6">
      <v-btn
        text
        ref="button-toolbar-close"
        @click="closeViewInboxMessageModal"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <v-card class="ma-4 rounded-lg custom_card" flat>
      <v-card-title class="justify-center">
        <span class="title font-weight-medium text-color">
          {{ $t('inbox.view.title') }}
        </span>
      </v-card-title>
      <v-card-text class="mt-4">
        <v-row>
          <!------------------------------------------>
          <!-- TITLE --------------------------------->
          <!------------------------------------------>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="6" class="d-flex justify-center">
                <p class="subtitle-1 font-weight-medium text-color">
                  {{ $t('inbox.view.subject') }}:
                </p>
              </v-col>
              <v-col cols="12" md="6" class="d-flex justify-center">
                <p class="text-color subtitle-1">{{ message.name }}</p>
              </v-col>
            </v-row>
          </v-col>
          <!------------------------------------------>
          <!-- ORGANIZATION -------------------------->
          <!------------------------------------------>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="6" class="d-flex justify-center">
                <p class="subtitle-1 font-weight-medium text-color">
                  {{ $t('inbox.view.organization') }}:
                </p>
              </v-col>
              <v-col cols="12" md="6" class="d-flex justify-center">
                <p class="text-color subtitle-1">
                  {{ message.organization ? message.organization.name : '-' }}
                </p>
              </v-col>
            </v-row>
          </v-col>
          <!------------------------------------------>
          <!-- STATUS -------------------------------->
          <!------------------------------------------>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="6" class="d-flex justify-center">
                <p class="subtitle-1 font-weight-medium text-color">
                  {{ $t('inbox.view.status') }}:
                </p>
              </v-col>
              <v-col cols="12" md="6" class="d-flex justify-center">
                <p class="text-color subtitle-1">
                  <v-chip
                    :color="message.is_completed ? 'success' : 'error'"
                    text-color="white"
                    class="rounded-lg"
                    :disabled="message.isLoading"
                  >
                    {{
                      message.is_completed
                        ? $t('inbox.table.completed')
                        : $t('inbox.table.not_completed')
                    }}
                  </v-chip>
                </p>
              </v-col>
            </v-row>
          </v-col>
          <!------------------------------------------>
          <!-- DESCRIPTION --------------------------->
          <!------------------------------------------>
          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="12" class="d-flex justify-center">
                <p class="subtitle-1 font-weight-medium text-color">
                  {{ $t('inbox.view.description') }}:
                </p>
              </v-col>
              <v-col cols="12" class="d-flex justify-center">
                <p
                  class="text-color
                    subtitle-1"
                >
                  {{ message.description }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ViewInboxMessageDialog',
  computed: {
    ...mapState({
      message: state => state.inbox.message,
      isViewInboxMessageModalOpen: state =>
        state.inbox.isViewInboxMessageModalOpen
    })
  },
  methods: {
    ...mapMutations({
      setMessage: 'inbox/setMessage',
      toggleViewInboxMessageModal: 'inbox/toggleViewInboxMessageModal'
    }),
    inputViewInboxMessageModal(args) {
      if (!args) {
        this.closeViewInboxMessageModal()
      }
    },
    closeViewInboxMessageModal() {
      this.setMessage({})
      this.toggleViewInboxMessageModal(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.text-color {
  color: #344054;
}
</style>
